import React from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { ReactSVG } from 'react-svg';

export const icons: any = {
  dot: '/images/icons/dot-v2.svg',
  live: '/images/icons/live-v2.svg',
  file: '/images/icons/filecsv-v2.svg',
  search: '/images/icons/search.svg',
  x: '/images/icons/x.svg',
  gear: '/images/icons/icon-gear.svg',
  creditCard: '/images/icons/icon-credit-card.svg',
  wrench: '/images/icons/icon-wrench.svg',
  stripeLogo: '/images/icons/icon-logo-stripe.svg',
  check: '/images/icons/icon-checkmark-v2.svg',
  alert: '/images/icons/icon-alert.svg',
  strategies: '/images/icons/strategies.svg',
  campaigns: '/images/icons/campaigns.svg',
  chevronRight: '/images/icons/chevron-right.svg',
  chevronUp: '/images/icons/chevron-up.svg',
  chevronDown: '/images/icons/chevron-down.svg',
  caretUp: '/images/icons/caret-up.svg',
  caretDown: '/images/icons/caret-down.svg',
  graph: '/images/icons/graph-v2.svg',
  circleX: '/images/icons/circle-x.svg',
  circleXV2: '/images/icons/circle-x-v2.svg',
  more: '/images/icons/more.svg',
  plus: '/images/icons/plus-v2.svg',
  linkIn: '/images/icons/link-in.svg',
  arrowUp: '/images/icons/arrow-up.svg',
  arrowDown: '/images/icons/arrow-down.svg',
  bookmark: '/images/icons/bookmark.svg',
  bookmarkFilled: '/images/icons/bookmark-filled.svg',
  youtubeLogo: '/images/icons/icon-logo-youtube.svg',
  home: '/images/icons/home.svg',
  orders: '/images/icons/orders.svg',
  barGraph: '/images/icons/bar-graph.svg',
  lightningBolt: '/images/icons/lightning-bolt.svg',
  shoppingBag: '/images/icons/shopping-bag.svg',
  instagramLogo: '/images/icons/icon-logo-instagram.svg',
  copy: '/images/icons/icon-copy.svg',
  arrowRight: '/images/icons/arrow-right.svg',
  columns: '/images/icons/columns.svg',
  filledAlert: '/images/icons/icon-alert-filled.svg',
  kebab: '/images/icons/icon-kebab.svg',
  linkOut: '/images/icons/linkout.svg',
  purse: '/images/icons/icon-purse.svg',
  pencil: '/images/icons/icon-pencil.svg',
  docs: '/images/icons/docs.svg',
  docsV2: '/images/icons/docs-v2.svg',
  keywords: '/images/icons/keywords.svg',
  collections: '/images/icons/collections.svg',
  heroProducts: '/images/icons/hero-products.svg',
  newProducts: '/images/icons/new-products.svg',
  salesTag: '/images/icons/sale-tag.svg',
  circleCheck: '/images/icons/circle-check.svg',
  circleCheckOutline: '/images/icons/circle-check-outline.svg',
  circleInfo: '/images/icons/circle-info.svg',
  circleWarning: '/images/icons/circle-warning.svg',
  document: '/images/icons/document.svg',
  eye: '/images/icons/public-eye.svg',
  editor: '/images/icons/edit.svg',
  createModule: 'images/icons/create-module.svg',
  whiteCheckmark: '/images/icons/checkmark-white.svg',
  checkmark: '/images/icons/checkmark.svg',
  calendar: '/images/icons/calendar.svg',
  calendarAdded: '/images/icons/calendar-added.svg',
  info: '/images/icons/dynamic-info.svg',
  samples: '/images/icons/samples.svg',
  payments: '/images/icons/payments.svg',
  globe: '/images/icons/globe.svg',
  cardView: '/images/icons/card-view.svg',
  listView: '/images/icons/list-view.svg',
  export: '/images/icons/export.svg',
  trash: 'images/icons/trash-can.svg',
  thumbLike: '/images/icons/thumb-like.svg',
  thumbLike2: '/images/icons/thumb-like2.svg',
  thumbDislike: '/images/icons/thumb-dislike.svg',
  questionMarkCircle: '/images/icons/question-mark-circle',
  ios: '/images/icons/ios.svg',
  newTag: '/images/icons/new-tag.svg',
  solidLightning: '/images/icons/solid-lightning.svg',
  grayLightning: '/images/icons/gray-lightning.svg',
  lightning: '/images/icons/icon-lightning.svg',
  card: '/images/icons/icon-card.svg',
  bank: '/images/icons/icon-bank.svg',
  violetRightArrow: 'images/icons/violet-right-arrow.svg',
  note: '/images/icons/note.svg',
  infoCircle: '/images/icons/info-circle.svg',
  lock: '/images/icons/lock.svg',
  userPlus: '/images/icons/user-plus.svg',
  profile: '/images/icons/profile.svg',
  sortDescending: '/images/icons/sort-descending.svg',
  sortAscending: '/images/icons/sort-ascending.svg',
  upload: '/images/icons/upload.svg',
  circleCheckGreen: '/images/icons/circle-check-green.svg',
  money: '/images/icons/money.svg',
  filters: '/images/icons/filters.svg',
};

const Icon = (props: any) => {
  const {
    iconName,
    size,
    color,
    image,
    onClick,
    className,
    colorClassName,
    pointerEvents,
  } = props;

  const iconSrc = icons[iconName];

  if (!iconSrc) {
    return null;
  }

  return (
    <div
      className={classNames(
        'flex items-center fill-current',
        className,
        colorClassName,
        {
          'pointer-events-none': !pointerEvents,
        },
      )}
      style={{
        height: `${size}px`,
        width: `${size}px`,
        color: !colorClassName && (color || 'inherit'),
      }}
    >
      {image ? (
        <img width={`${size}px`} height={`${size}px`} src={iconSrc} alt={''} />
      ) : (
        <ReactSVG src={iconSrc} onClick={onClick} />
      )}
      {/* <img src={iconSrc} alt={''} /> */}
    </div>
  );
};

Icon.propTypes = {
  color: PropTypes.string,
  iconName: PropTypes.oneOf(Object.keys(icons)).isRequired,
  size: PropTypes.number,
  onClick: PropTypes.func,
  className: PropTypes.string,
  image: PropTypes.bool,
  colorClassName: PropTypes.string,
  pointerEvents: PropTypes.bool,
};

Icon.defaultProps = {
  color: null,
  size: 16,
  onClick: () => null,
  pointerEvents: false,
};

export default Icon;
